import { render } from "./BasketballShorts_5_front.vue?vue&type=template&id=ccfe4268"
import script from "./BasketballShorts_5_front.vue?vue&type=script&lang=js"
export * from "./BasketballShorts_5_front.vue?vue&type=script&lang=js"

import exportComponent from "/srv/users/dyo-frontend-staging/apps/dyo-frontend-staging/public_html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__